export const ADVISOR_BOOK_ONBOARDING_WIZARD_STEPS = [
  { slug: 'welcome', label: 'Welcome', backendCurrentStep: 'step1' },
  { slug: 'how-it-works', label: 'How onboarding works', backendCurrentStep: 'step2' },
  { slug: 'personalize', label: 'Personalize', backendCurrentStep: 'step4' },
] as const;

export type AdvisorBookOnboardingWizardStepSlug = (typeof ADVISOR_BOOK_ONBOARDING_WIZARD_STEPS)[number]['slug'];

export type AdvisorBookOnboardingWizardStep = (typeof ADVISOR_BOOK_ONBOARDING_WIZARD_STEPS)[number];

export const ADVISOR_BOOK_ONBOARDING_WIZARD_STEP_QUERY_KEY = 'step';
